export default __webpack_public_path__ + "static/media/Tamkeen_Logo_New.96c1b127.png";